/**
 * AJ Lead Capture — inline surface.
 *
 * Renders the offer card directly into a target container (shortcode slot).
 * No close button, no animation; placement is the targeting.
 *
 * @module inline
 */

import { buildCard } from './markup';

/**
 * Render an inline offer into a container.
 *
 * @param {HTMLElement} target           Container to render into.
 * @param {Object}      offer            Offer config.
 * @param {Object}      [opts]           Options.
 * @param {Function}    [opts.onSubmit]  Submit handler(email) -> Promise.
 * @returns {{root: HTMLElement}}
 */
export function renderInline(target, offer, opts = {}) {
  const wrap = document.createElement('div');
  wrap.className = 'aj-lo-inline';

  const card = buildCard(offer, {
    showClose: false,
    onSubmit: opts.onSubmit,
  });

  wrap.appendChild(card.root);
  target.innerHTML = '';
  target.appendChild(wrap);

  return { root: wrap };
}
